/* PhotoHouse V1: progressively enhances the old Kingdom theme. It never calls
   cart APIs or writes to the selected Shopify variant. The original product
   form and theme.js remain authoritative. */
(function () {
  'use strict';

  function text(element) {
    return element ? (element.textContent || '').trim() : '';
  }

  function initProduct(article) {
    if (!article || article.dataset.phV1Init === '1') return;
    article.dataset.phV1Init = '1';

    var summary = article.querySelector('[data-ph-v1-choice-summary]');
    var selects = Array.prototype.slice.call(article.querySelectorAll('.product__variant'));
    function updateChoiceSummary() {
      if (!summary) return;
      var rows = summary.querySelectorAll('[data-ph-v1-option-index]');
      Array.prototype.forEach.call(rows, function (row) {
        var index = Number(row.getAttribute('data-ph-v1-option-index'));
        var select = selects[index];
        var value = row.querySelector('[data-ph-v1-value]');
        if (select && value && select.selectedIndex >= 0) {
          var selectedText = select.options[select.selectedIndex].text;
          var labelNode = row.querySelector('.ph-v1__choice-label');
          var optionLabel = labelNode ? labelNode.textContent : '';
          // Label only: Shopify's original option, variant and stock data stay intact.
          if (/frame|מסגר/i.test(optionLabel) &&
              /הדפסה בלבד|הדפס בלבד|ללא מסגרת|printing only|print only|without frame|no frame|unframed/i.test(selectedText)) {
            selectedText = /^he/i.test(document.documentElement.lang || '') ? 'ללא מסגרת' : 'No frame';
          }
          value.textContent = selectedText;
        }
      });
    }

    selects.forEach(function (select) { select.addEventListener('change', updateChoiceSummary); });
    // Kingdom triggers some selector changes through jQuery's synthetic event
    // rather than dispatching a native DOM change event.
    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(selects).on('change.phV1', updateChoiceSummary);
    }
    // The old theme sometimes changes the select value and its rendered custom
    // label through jQuery alone. Observing this small selector subtree keeps
    // the recap accurate even if that change did not emit a DOM change event.
    var optionHolder = article.querySelector('.product__variants');
    if (summary && optionHolder) {
      var optionObserver = new MutationObserver(updateChoiceSummary);
      optionObserver.observe(optionHolder, { childList: true, characterData: true, subtree: true });
    }
    updateChoiceSummary();

    var sectionId = article.id.replace(/^section-/, '');
    var mobileBar = Array.prototype.slice.call(document.querySelectorAll('[data-ph-v1-mobile-atc]')).find(function (el) {
      return el.dataset.productSection === sectionId;
    });
    var originalButton = article.querySelector('.product__add-to-cart');
    var originalPrice = article.querySelector('.product__price--original');
    if (!mobileBar || !originalButton || !originalPrice) return;

    var stickyButton = mobileBar.querySelector('[data-ph-v1-mobile-button]');
    var stickyPrice = mobileBar.querySelector('[data-ph-v1-mobile-price]');
    if (!stickyButton || !stickyPrice) return;

    function updateSticky() {
      stickyPrice.textContent = text(originalPrice);
      var origText = text(originalButton.querySelector('.add-to-cart__text'));
      if (origText) stickyButton.textContent = origText;
      var unavailable = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true' ||
        originalButton.classList.contains('disabled') || originalButton.classList.contains('working') ||
        originalButton.classList.contains('done') || originalButton.classList.contains('clear');
      stickyButton.disabled = !!unavailable;
    }

    function updateVisibility() {
      if (!window.matchMedia('(max-width: 767px)').matches) {
        mobileBar.classList.remove('is-visible');
        return;
      }
      var rect = originalButton.getBoundingClientRect();
      var shouldShow = rect.bottom < -12 && originalButton.isConnected;
      mobileBar.classList.toggle('is-visible', shouldShow);
      updateSticky();
    }

    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled && originalButton.isConnected) {
        // Click the site's real add-to-cart button, preserving all apps and Shopify logic.
        originalButton.click();
        updateSticky();
      }
    });

    var buttonObserver = new MutationObserver(updateSticky);
    buttonObserver.observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
    var priceObserver = new MutationObserver(updateSticky);
    priceObserver.observe(originalPrice, { childList: true, characterData: true, subtree: true });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();
  }

  function mount() {
    if (!document.body || !document.body.classList.contains('ph-v1') || document.body.classList.contains('template-product-portfolio')) return;
    Array.prototype.forEach.call(document.querySelectorAll('.template-product .product.page-section'), initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
